import { observer } from 'mobx-react-lite'
import React from 'react'
import classNames from 'classnames'
import { Button } from 'shared/ui'
import { LINK_REFERRALS_HELP_GUIDE } from 'shared/constants/links'
import { useReferralsViewContext } from 'pages/settings/pages/referrals/context/referralsViewContext'
import styles from './styles.module.scss'

export const ReferralsActions = observer(() => {
  const { createReferrals } = useReferralsViewContext()

  return (
    <div className={classNames(styles.actionsContainer)}>
      <Button
        text='Start referring'
        size='medium'
        onClick={createReferrals}
        className={styles.actionButton}
      />
      <Button
        tag='a'
        text='Help guide'
        size='medium'
        contained='secondary'
        iconProps={{ icon: 'info' }}
        className={classNames(styles.helpButton)}
        href={LINK_REFERRALS_HELP_GUIDE}
        target='_blank'
        rel='noreferrer'
      />
    </div>
  )
})
